import React from 'react'

const ErrorMessage = ({ error }) => {
  const errorText = typeof error === 'object' ? error.message : error ; 
  return <p className="form-message error">
    {errorText}
  </p>
}

export default ErrorMessage;